import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../../../panel/Panel";
import Form from "./forms/Edit";
import {removeAction as removePanelAction} from "../../../../actions/panel";
import { InsuranceOutlined } from '@ant-design/icons';
import { Button, Divider, Result, Spin } from "antd";
import EntityLoader from "../../../common/EntityLoader";
import ServiceList from "./service/List";

const Title = ({entity}) => <span>
    <InsuranceOutlined /> {!!entity ? entity.name : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, onRemovePanel, siteId}) => <>
    {entity
        ? <>
            <Form groupId={entityId} siteId={siteId}/>
            <Divider/>
            <ServiceList groupId={entityId}/>
        </>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`cookieconsentsitegroups:${entityId}:edit`)}>close</Button>}
        />
    }
</>);

export default ({groupId, siteId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        backgroundColor="#882f9c"
        id={`cookieconsentsitegroups:${groupId}:edit`}
        title={
            <EntityLoader entityId={groupId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={groupId} onFinally={() => setLoading(false)}>
                <Content siteId={siteId}/>
            </EntityLoader>
        </Spin>
    </Panel>
};
